// Préférences d'affichage du compte (table sx_user_pref, PATCH
// /api/me/preferences, renvoyées par /api/me/full). La base fait foi : on les
// retrouve sur tout appareil. Le localStorage n'en garde qu'une copie, relue
// par public/theme-init.js avant le premier rendu pour éviter un saut
// d'affichage (taille du texte, thème).
import { apiPatch } from './api';
import { applyFontSize, parseFontSize, type FontSize } from './fontSize';
import { applyThemePref, parseThemePref, storedTheme, type ThemePref } from './theme';

export type MessageOrder = 'recent_first' | 'oldest_first';
/** Couleur V1 dans les listes : case « État » seulement (défaut) ou toute la ligne. */
export type RowColor = 'etat' | 'ligne';

export interface Preferences {
  font_size?: FontSize;
  message_order?: MessageOrder;
  /** null : jamais choisi pour ce compte. */
  theme?: ThemePref | null;
  row_color?: RowColor;
}

export const DEFAULT_MESSAGE_ORDER: MessageOrder = 'recent_first';

export function parseMessageOrder(v: unknown): MessageOrder {
  return v === 'oldest_first' ? 'oldest_first' : DEFAULT_MESSAGE_ORDER;
}

export function parseRowColor(v: unknown): RowColor {
  return v === 'ligne' ? 'ligne' : 'etat';
}

export async function savePreferences(patch: Partial<Record<'font_size' | 'message_order' | 'theme' | 'row_color', string>>): Promise<void> {
  await apiPatch('/api/me/preferences', patch);
}

/**
 * Applique les préférences lues sur le serveur. Thème jamais enregistré pour
 * ce compte mais choisi sur cet appareil (avant que le thème soit en base) :
 * on l'enregistre, une fois, plutôt que de l'écraser.
 */
export function applyServerPreferences(prefs: Preferences | undefined): void {
  if (!prefs) return;
  const size = parseFontSize(prefs.font_size);
  if (size) applyFontSize(size);
  const theme = parseThemePref(prefs.theme);
  if (theme) {
    applyThemePref(theme);
  } else {
    const local = storedTheme();
    if (local) void savePreferences({ theme: local }).catch(() => {});
  }
}
